module.exports = __webpack_public_path__ + "img/tile_your-opportunity.dc308d73.jpg";